export function setFormErrors(errors, commit) {
    if (errors) {
        Object.entries(errors).forEach((e) => {
            commit('setError', {
                field: e[0],
                error: e[1][0],
            })
        })
        return true
    }
    return false
}

export default { setFormErrors }
